export default __webpack_public_path__ + "static/infinity-card-w-illustrations-da89ddbcc8d0fd3bf666a39039c26070.png";